import { Component, Host, h, Prop, Element, Watch } from '@stencil/core';

export type AuiIconSize = 'min' | 'std' | 'max';

export type AuiIconColor = 'blue-dark' | 'gray-darker' | 'orange-medium';

@Component({
  tag: 'aui-icon',
  styleUrl: 'aui-icon.scss',
  shadow: false,
})
export class AuiIcon {
  static baseAssetsUrl = 'https://assets.avalara.com/skylab-images/icons';

  static validSizes: AuiIconSize[] = ['std', 'min', 'max']; // default is at index 0

  static validColors: AuiIconColor[] = ['blue-dark', 'gray-darker', 'orange-medium']; // default is at index 0

  @Prop() name: string;

  @Prop() alt: string;

  @Prop({ reflect: true }) size: AuiIconSize;

  @Prop({ reflect: true }) color: AuiIconColor;

  @Element() element: HTMLAuiImageElement;

  @Watch('size')
  watchSize() {
    if (!AuiIcon.validSizes.includes(this.size)) {
      [this.size] = AuiIcon.validSizes;
    }
  }

  @Watch('color')
  watchColor() {
    if (!AuiIcon.validColors.includes(this.color)) {
      [this.color] = AuiIcon.validColors;
    }
  }

  connectedCallback() {
    this.watchSize();
    this.watchColor();
  }

  #getFullImageUrl() {
    // combine the paths.  The '' results in paths ending with a '/'.
    const baseUrl = [AuiIcon.baseAssetsUrl, this.color, this.size, ''].join('/');

    return new URL(`${this.name}.svg`, baseUrl).href;
  }

  render() {
    return (
      <Host>
        <img src={this.#getFullImageUrl()} alt={this.alt} class={this.size} />
      </Host>
    );
  }
}
